import { useDictionary } from '@/shared/api';
import type { AssetsAsset } from '@/shared/types';

interface UseAssetsOptions {
  enabled?: boolean;
}

export function useAssets(options: UseAssetsOptions = {}) {
  return useDictionary<AssetsAsset[]>({
    dictionaryName: 'assets',
    enabled: options.enabled,
  });
}
